import { createSlice }       from '@reduxjs/toolkit';
import * as settingsReducers from 'Redux/Reducers/Settings';

export interface ISettingsState {
  updatedAt: number,
  openRequests: string[],
  failedRequests: string[],
  entries: {
    TICKET_PERCENTAGE_FEE: string,
    TRANSACTION_FEE: string,
    TRANSACTION_FEE_TAX: string,
    SHIPPING_COSTS: string,
    TERMS_OF_AGREEMENT: string,
    IMPRINT: string,
    TERMS_OF_USE: string,
  },
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    updatedAt: 0,
    openRequests: [],
    failedRequests: [],
    entries: {
      TICKET_PERCENTAGE_FEE: '7.5',
      TRANSACTION_FEE: '50',
      TRANSACTION_FEE_TAX: '19',
      SHIPPING_COSTS: '595',
      TERMS_OF_AGREEMENT: '<p></p>',
      IMPRINT: '<p></p>',
      TERMS_OF_USE: '<p></p>',
    },
  },
  reducers: settingsReducers,
});
